import React from 'react';
import styled from '@emotion/styled';
import mq from "../../Styles/breakpoints";
import { fontSize } from "../../Styles/text";
import { css } from '@emotion/core';
import { asset } from './helpers';

let HeroBlock = styled.div`
  position: relative;
  margin-top: -3vw;
  padding-bottom: 42.5%;
`;

let Background = styled.img`
  position: absolute;
  width: 100%:
  display: block;
`;

let Inner = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 16px;
  background: rgba(0,0,0,0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #fff;
  text-align: center;

  @media(min-width: 900px) {
    background: rgba(0,0,0,0.7);
  }

  h1 {
    max-width: 750px;
    // https://css-tricks.com/snippets/css/fluid-typography/
    // font-size: calc([minimum size] + ([maximum size] - [minimum size]) * ((100vw - [minimum viewport width]) / ([maximum viewport width] - [minimum viewport width])));
    font-size: calc(24px + (72 - 24) * ((100vw - 320px) / (1920 - 320)));
    font-weight: 500;
  }

  p {
    max-width: calc(480px + (1000 - 480) * ((100vw - 320px) / (1920 - 320)));;
    margin-bottom: 0;
    font-size: calc(16px + (32 - 16) * ((100vw - 320px) / (1920 - 320)));
  }
`;

function Hero(props) {
  const Spacer = styled.div`
    color: white;
    margin-top: 0vh;
    width: 100%;
    padding: 40px;
   
    ${mq.large(`
      margin-top: 8vh;
    `)}; 
  `;

  const H1 = styled.h1`
    color:white;
    line-height:1.1;
    margin-bottom: .5em;
    font-size: 1.6em;
    
    ${mq.large(`
      font-size: 2em;
      max-width: 540px;
    `)}; 
  `;

  const videoAppLogoStyles = css`
      width: 154px; 
  `;

  return (
    <HeroBlock>
      <Background
        src={asset('streaming/stream-grid.jpg')}
        srcSet={`${asset('streaming/stream-grid.jpg')} 1920w, ${asset('streaming/stream-grid.1440.jpg')} 1440w, ${asset('streaming/stream-grid.1366.jpg')} 1366w, ${asset('streaming/stream-grid.768.jpg')} 768w, ${asset('streaming/stream-grid.480.jpg')} 480w, ${asset('streaming/stream-grid.320.jpg')} 320w`}
        sizes={"(max-width: 320px) 320px, (max-width: 480px) 480px, (max-width: 768px) 768px, (max-width: 1366px) 1366px, (max-width: 1400px) 1400px, 1920px"}
        alt=""
      />
      <Inner>
        <H1>Start Streaming TPT</H1>
        <p>
          Stream select shows now or open the door to everything by becoming a member and gaining access to TPT Passport
        </p>
      </Inner>
    </HeroBlock>
  );
}

export default Hero;